import React from 'react';
import PageHero from './PageHero';
import visionImg from '../assets/Banner-GMIS Students.png';
import missionImg from '../assets/GMIS Backyard View.png';

export default function VisionMissionPage({ setPage, t }) {
  const { visionMission: vm } = t;

  return (
    <div className="w-full bg-paper">
            {/* ── Hero ─────────────────────────────────────────────────────────────── */}
      <PageHero title={vm.title} breadcrumbs={["Home","About Us","Vision & Mission"]} eyebrow={vm.eyebrow} subtitle={vm.subtitle} />


      {/* ── Content Section ── */}
      <div className="max-w-[1200px] mx-auto px-6 lg:px-[80px] py-24 box-border">
        
        {/* Vision */}
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16 mb-24">
          <div className="md:w-5/12">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-gold/10 rounded-2xl" />
              <img src={visionImg} alt="Vision" className="relative z-10 w-full h-[400px] rounded-3xl shadow-2xl object-cover border-4 border-white" />
            </div>
          </div>
          <div className="md:w-7/12 flex flex-col gap-6 text-[17px] leading-[1.8] text-ink/80 text-left">
            <div className="inline-block mb-2">
              <h2 className="m-0 font-heading font-medium text-[40px] text-navy tracking-[-0.015em] uppercase">
                {vm.visionTitle}
              </h2>
              <div className="w-16 h-1 bg-gold mt-4" />
            </div>
            <p className="text-[24px] font-medium text-navy leading-[1.5] mb-2">
              {vm.visionParagraphs[0]}
            </p>
            {vm.visionParagraphs.slice(1).map((paragraph, idx) => (
              <p key={idx}>{paragraph}</p>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-black/5 mb-24" />

        {/* Mission */}
        <div className="flex flex-col md:flex-row-reverse items-center gap-10 md:gap-16">
          <div className="md:w-5/12">
            <div className="relative">
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-navy/5 rounded-2xl" />
              <img src={missionImg} alt="Mission" className="relative z-10 w-full h-[450px] rounded-3xl shadow-2xl object-cover border-4 border-white" />
            </div>
          </div>
          <div className="md:w-7/12 flex flex-col gap-6 text-[17px] leading-[1.8] text-ink/80 text-left">
            <div className="inline-block mb-2 text-left">
              <h2 className="m-0 font-heading font-medium text-[40px] text-navy tracking-[-0.015em] uppercase">
                {vm.missionTitle}
              </h2>
              <div className="w-16 h-1 bg-gold mt-4 ml-0" />
            </div>
            <p className="text-[24px] font-medium text-navy leading-[1.5] mb-2">
              {vm.missionParagraphs[0]}
            </p>
            {vm.missionParagraphs.slice(1).map((paragraph, idx) => (
              <p key={idx}>{paragraph}</p>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}
